import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import { translate } from '~/core/translate'
import { getDialogProps } from '~/selectors/ui'

import Item from './add/item'
import Button from '~/components/common/button'
import { hideDialog } from '~/actions/ui'
import { removeRecordFromMeeting } from '~/actions/salesforce'
import Modal from '~/components/common/modal'

const StyledItem = styled(Item)`
  margin: 16px 0;
`

const Remove = () => {
  const dispatch = useDispatch()
  const { recordId } = useSelector(getDialogProps)

  const confirm = useCallback(() => {
    dispatch(removeRecordFromMeeting({ recordId }))
    hideDialog()
  }, [dispatch, recordId])

  return (
    <Modal
      footerChildren={(
        <>
          <Button onClick={hideDialog} variant='tertiary'>{translate('cancel')}</Button>
          <Button onClick={confirm}>{translate('salesforce_remove')}</Button>
        </>
      )}
      title={translate('salesforce_remove_meeting')}
    >
      <div>{translate('salesforce_remove_meeting_confirm')}</div>

      <StyledItem recordId={recordId} />
    </Modal>
  )
}

export default Remove
